export class PaginationFilters {
	page?: number;
	size?: number;

	constructor(init?: PaginationFilters) {
		Object.assign(this, init);
	}
}
